import { AlterarStatusMensagemEUsuarioOrigemEDestinoPorId } from "./metodos/AlterarStatusMensagemEUsuarioOrigemEDestinoPorId";
import { AutorizarLiberacoesBaixaContasAPagar } from "./metodos/AutorizarLiberacoesBaixaContasAPagar";
import { GerarToken } from "./metodos/GerarToken";
import { ObterContasAPagarPendentes } from "./metodos/ObterContasAPagarPendentes";
import { ObterDetalhesDaInclusaoDeContasAPagar } from "./metodos/ObterDetalhesDaInclusaoDeContasAPagar";
import { ObterDetalhesDaInclusaoDeContasAPagarConsulta } from "./metodos/ObterDetalhesDaInclusaoDeContasAPagarConsulta";
import { ObterDetalhesDeContasAPagarPendente } from "./metodos/ObterDetalhesDeContasAPagarPendente";
import { ObterDetalhesDeJuros } from "./metodos/ObterDetalhesDeJuros";
import { ObterDetalhesSolicitacaoFinanceira } from "./metodos/ObterDetalhesSolicitacaoFinanceira";
import { ObterDocumentosDoLoteAgrupadosPorLoja } from "./metodos/ObterDocumentosDoLoteAgrupadosPorLoja";
import { ObterSolicitacaoSenhaPorId } from "./metodos/ObterSolicitacaoSenhaPorId";
import { ObterSolicitacoesDoUsuario } from "./metodos/ObterSolicitacoesDoUsuario";
import { ObterSolicitacoesDoUsuarioComFiltroDeData } from "./metodos/ObterSolicitacoesDoUsuarioComFiltroDeData";
import { ObterSolicitacoesPendentesSolicitadasPeloUsuario } from "./metodos/ObterSolicitacoesPendentesSolicitadasPeloUsuario";
import { ObterValoresDoLoteDeContasAPagar } from "./metodos/ObterValoresDoLoteDeContasAPagar";
import { ObterVencimentosDoLoteDeContasAPagar } from "./metodos/ObterVencimentosDoLoteDeContasAPagar";
import { RecusarSolicitacaoSenhaMarcada } from "./metodos/RecusarSolicitacaoSenhaMarcada";
import { ResponderSolicitacao } from "./metodos/ResponderSolicitacao";

export const SolicitacaoDeSenhaService = {
    AlterarStatusMensagemEUsuarioOrigemEDestinoPorId,
    AutorizarLiberacoesBaixaContasAPagar,
    ObterSolicitacoesDoUsuario,
    ObterSolicitacoesDoUsuarioComFiltroDeData,
    ObterSolicitacaoSenhaPorId,
    ObterSolicitacoesPendentesSolicitadasPeloUsuario,
    ResponderSolicitacao,
    ObterDocumentosDoLoteAgrupadosPorLoja,
    ObterValoresDoLoteDeContasAPagar,
    ObterContasAPagarPendentes,
    ObterDetalhesDeContasAPagarPendente,
    ObterVencimentosDoLoteDeContasAPagar,
    ObterDetalhesSolicitacaoFinanceira,
    ObterDetalhesDaInclusaoDeContasAPagar,
    ObterDetalhesDaInclusaoDeContasAPagarConsulta,
    ObterDetalhesDeJuros,
    RecusarSolicitacaoSenhaMarcada,
    GerarToken
}